import { atom } from 'jotai';

export const RESOLUTION = 5;

export const usedSelectedHexsAtom = atom<string[]>([]);
export const newSelectedHexsAtom = atom<string[]>([]);
